(() => {
  if (customElements.get('lp-petal-size-chart')) return;
  let preferredUnit = 'inches';
  class PetalSizeChart extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-petal-unit]');
        if (!button || !this.contains(button)) return;
        preferredUnit = button.dataset.petalUnit;
        document.querySelectorAll('lp-petal-size-chart').forEach((chart) => chart.setUnit(preferredUnit));
      });
      this.setUnit(preferredUnit);
    }
    setUnit(unit) {
      this.dataset.unit = unit;
      this.querySelectorAll('[data-petal-unit]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.petalUnit === unit)));
      this.querySelectorAll('[data-petal-unit-table]').forEach((table) => { table.hidden = table.dataset.petalUnitTable !== unit; });
    }
  }
  customElements.define('lp-petal-size-chart', PetalSizeChart);
  class PetalDelivery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      this.select = this.querySelector('[data-petal-destination]');
      this.arrival = this.querySelector('[data-petal-arrival]');
      if (!this.select || !this.arrival) return;
      this.select.addEventListener('change', (event) => {
        event.stopPropagation();
        this.update();
      });
      this.update();
    }
    update() {
      const option = this.select.selectedOptions[0];
      const root = this.closest('.lp-petal-purchase');
      const hasEstimate = Boolean(option?.value);
      if (hasEstimate) {
        this.arrival.textContent = option.dataset.arrival;
        root.querySelector('[data-petal-shipping-rate]').textContent = option.dataset.rate;
      } else {
        this.arrival.textContent = this.select.options[0].textContent;
        root.querySelector('[data-petal-shipping-rate]').textContent = root.dataset.defaultRate;
      }
      this.querySelector('[data-petal-estimate-note]').hidden = !hasEstimate;
      this.querySelector('[data-petal-fallback-note]').hidden = hasEstimate;
      root.querySelector('[data-petal-australia-note]').hidden = option.value !== 'AU';
    }
  }
  customElements.define('lp-petal-delivery', PetalDelivery);
})();
